export default {
  'seo.common.title': '创元B2B包材电商平台_美妆包材一站式采购平台。',
  'seo.detail.title': '{name}_创元B2B包材电商平台',
  'seo.menu.title': '{name}_创元B2B包材电商平台',
  'seo.common.description':
    '创元B2B包材商城提供美妆行业的包材产品开发、包装设计、包装开发、材料研发、产品制造、产品交易、供应链服务一体化解决方案。',
  'seo.detail.description': '{name}_创元B2B包材电商平台 ',
  'seo.common.keywords':
    '创元，包装材料，化妆品包材，包装设计，包装开发，材料研发，模具开发，包材交易，包材生产，包材供应。',
};
